/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Assistant_Cap_ReachedInputs */

const en_error_assistant_cap_reached = /** @type {(inputs: Error_Assistant_Cap_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant has spent this month's limit. It answers again next month.`)
};

/**
* | output |
* | --- |
* | "The assistant has spent this month's limit. It answers again next month." |
*
* @param {Error_Assistant_Cap_ReachedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_assistant_cap_reached = /** @type {((inputs?: Error_Assistant_Cap_ReachedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Assistant_Cap_ReachedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_assistant_cap_reached(inputs)
});